import React, {ReactElement} from 'react';
import classnames from 'classnames';

import styles from 'src/components/Stamp/Stamp.module.scss';

// Needed for certain jsx files, should not be used for new tsx files
export const BLACK = 'black';
export const BLUE = 'blue';
export const GREEN = 'green';
export const MARIGOLD = 'marigold';
export const RED = 'red';
export const YELLOW = 'yellow';
export const CYAN = 'cyan';
export const GRAY = 'gray';
export const DARK_GREEN = 'dark-green';
export const VIOLET = 'violet';

export type StampColors =
  | ''
  | 'black'
  | 'blue'
  | 'green'
  | 'marigold'
  | 'red'
  | 'yellow'
  | 'cyan'
  | 'gray'
  | 'dark-green'
  | 'violet';

type Props = React.PropsWithChildren<{
  color?: StampColors;
  className?: string;
  ['data-testid']?: string;
}>;

const Stamp = ({color, children, className, 'data-testid': dataTestid}: Props): ReactElement => {
  const computedColor = color ? color : 'black';

  return (
    <div
      className={classnames('stamp', computedColor, styles.stamp, styles[computedColor], className)}
      data-testid={dataTestid}
    >
      {children}
    </div>
  );
};

export default Stamp;
